import 'desvg'
import '@/img/_ogp.jpg'
import pagesCommon from './pages/_common'
import pagesHome from './pages/home/_index'
import pagesAbout from './pages/about/_index'
import pagesConcept from './pages/concept/_index'
import pagesTopics from './pages/topics/_index'

window.addEventListener('load', () => {
    deSVG('img[inline]', true)
    pagesCommon()
    pagesHome()
    pagesAbout()
    pagesConcept()
    pagesTopics()
 })